/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefBillingHistoryListResponse } from '../../models/api-def-billing-history-list-response';

export interface OrganizationsGetBillingHistory$Params {

/**
 * The ID of the organization
 */
  organizationId: string;

/**
 * Legacy offset page used only when cursor is omitted. When cursor is present, this value is response metadata and does not affect the Firestore continuation boundary.
 */
  page?: number;
  limit?: number;
  skipCount?: boolean;

/**
 * Opaque organization-bound continuation cursor returned as nextCursor by the preceding response.
 */
  cursor?: string;
}

export function organizationsGetBillingHistory(http: HttpClient, rootUrl: string, params: OrganizationsGetBillingHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefBillingHistoryListResponse>> {
  const rb = new RequestBuilder(rootUrl, organizationsGetBillingHistory.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('skipCount', params.skipCount, {});
    rb.query('cursor', params.cursor, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiDefBillingHistoryListResponse>;
    })
  );
}

organizationsGetBillingHistory.PATH = '/organizations/{organizationId}/billing/history';
